// src/screens/PagarCuotaScreen.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, functions } from '../firebaseConfig';
import { collection, query, where, onSnapshot, orderBy, writeBatch, doc, Timestamp, getDoc, addDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
// eslint-disable-next-line no-unused-vars
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useAuth } from '../context/AuthContext';
import {
  IoArrowBack,
  IoWalletOutline,
  IoPrintOutline,
  IoClose,
  IoReceiptOutline,
  IoCheckmarkCircle,
  IoDocumentTextOutline,
  IoEyeOutline,
  IoDownloadOutline,
  IoShareSocialOutline,
  IoCloseCircle,
  IoAlertCircle,
  // eslint-disable-next-line no-unused-vars
  IoCodeWorkingOutline
} from 'react-icons/io5';
import moment from 'moment';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

// --- STRIPE IMPORTS ---
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import StripePaymentForm from '../components/StripePaymentForm';
import './PagarCuotaScreen.css';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';

// Import Kondo Logo
import kondoLogo from '../assets/Kondify letra negra sin fondo.png';

// TODO: REEMPLAZA CON TU PUBLISHABLE KEY DE STRIPE (Empieza con pk_test_...)
const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
if (!stripeKey) {
  console.warn("⚠️ REACT_APP_STRIPE_PUBLISHABLE_KEY no está definida en las variables de entorno.");
}
const stripePromise = stripeKey ? loadStripe(stripeKey) : null;

// URL del backend (Production Cloud Run 2nd Gen)
const API_URL = "https://createpaymentintent-owbzz4mskq-uc.a.run.app";

const StatusBadge = ({ estatus, fechaVencimiento }) => {
  let className = 'payment-status-badge';
  let texto = estatus;

  if (estatus === 'pendiente') {
    if (moment(fechaVencimiento.toDate()).isBefore(moment(), 'day')) {
      className += ' vencido';
      texto = 'Vencido';
    } else {
      className += ' pendiente';
      texto = 'Pendiente';
    }
  } else if (estatus === 'pagado') {
    className += ' pagado';
    texto = 'Pagado';
  }

  return <span className={className}>{texto}</span>;
};

const formatCurrency = (amount) => `$${new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(amount)}`;

function PagarCuotaScreen() {
  const navigate = useNavigate();
  const { currentUser, userData } = useAuth();
  const [cargos, setCargos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cargosSeleccionados, setCargosSeleccionados] = useState({});

  // Estados para Stripe
  const [mostrarStripe, setMostrarStripe] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [iniciandoPago, setIniciandoPago] = useState(false);
  const [montoAPagarStripe, setMontoAPagarStripe] = useState(0);
  const [idsProcesadosStripe, setIdsProcesadosStripe] = useState([]);

  // Custom Alert Modal State
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: '',
    message: '',
    type: 'success', // success | error | warning | confirm
    confirmText: 'Aceptar',
    cancelText: null,
    onConfirm: null,
    onCancel: null
  });

  const showAlert = (title, message, type = 'success', onConfirm = null, confirmText = 'Aceptar', cancelText = null, onCancel = null) => {
    setAlertConfig({
      show: true,
      title,
      message,
      type,
      confirmText,
      cancelText,
      onConfirm,
      onCancel
    });
  };

  const closeAlert = () => {
    setAlertConfig(prev => ({ ...prev, show: false }));
  };
  const [generatingPdf, setGeneratingPdf] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [showPdfViewer, setShowPdfViewer] = useState(false);
  const [logoImage, setLogoImage] = useState(null);
  const [mesesAdelantar, setMesesAdelantar] = useState(6);
  const [procesandoPrepago, setProcesandoPrepago] = useState(false);
  const [cuotaMensual, setCuotaMensual] = useState(1500);
  const [condoName, setCondoName] = useState('');
  const [desc3Meses, setDesc3Meses] = useState(0);
  const [desc6Meses, setDesc6Meses] = useState(0);
  const [desc12Meses, setDesc12Meses] = useState(0);
  const [tipoDesc3Meses, setTipoDesc3Meses] = useState('percentage');
  const [tipoDesc6Meses, setTipoDesc6Meses] = useState('percentage');
  const [tipoDesc12Meses, setTipoDesc12Meses] = useState('percentage');

  useEffect(() => {
    if (!userData?.condominioId) return;
    const fetchCondoConfig = async () => {
      try {
        const configSnap = await getDoc(doc(db, 'condominios', userData.condominioId, 'configuracion_cuotas', 'mensual'));
        if (configSnap.exists()) {
          const data = configSnap.data();
          setCuotaMensual(Number(data.monto) || 1500);
          setDesc3Meses(Number(data.desc3Meses) || 0);
          setDesc6Meses(Number(data.desc6Meses) || 0);
          setDesc12Meses(Number(data.desc12Meses) || 0);
          setTipoDesc3Meses(data.tipoDesc3Meses || 'percentage');
          setTipoDesc6Meses(data.tipoDesc6Meses || 'percentage');
          setTipoDesc12Meses(data.tipoDesc12Meses || 'percentage');
        }
        const condoSnap = await getDoc(doc(db, 'condominios', userData.condominioId));
        if (condoSnap.exists()) {
          setCondoName(condoSnap.data().nombre || condoSnap.data().name || '');
        }
      } catch (e) {
        console.error("Error fetching condo config:", e);
      }
    };
    fetchCondoConfig();
  }, [userData]);

  useEffect(() => {
    const img = new Image();
    img.onload = () => setLogoImage(img);
    img.src = kondoLogo;
  }, []);

  useEffect(() => {
    if (!currentUser?.uid || !userData?.condominioId) return;

    let q;
    if (userData?.numeroCasa && userData.numeroCasa !== 'N/A') {
      q = query(
        collection(db, "cargos"),
        where("condominioId", "==", userData.condominioId),
        where("unidadResidente", "==", userData.numeroCasa),
        orderBy("fechaVencimiento", "desc")
      );
    } else {
      q = query(
        collection(db, "cargos"),
        where("residenteId", "==", currentUser.uid),
        orderBy("fechaVencimiento", "desc")
      );
    }
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const listaCargos = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setCargos(listaCargos);
      setLoading(false);
    }, (error) => {
      console.error("Error al cargar cargos: ", error);
      setLoading(false);
    });
    return () => unsubscribe();
  }, [currentUser]);

  const handleSelectCargo = (id, monto) => {
    setCargosSeleccionados(prev => {
      const newSelection = { ...prev };
      if (newSelection[id]) {
        delete newSelection[id];
      } else {
        newSelection[id] = monto;
      }
      return newSelection;
    });
  };

  const totalAPagar = Object.values(cargosSeleccionados).reduce((sum, monto) => sum + monto, 0);

  // Calcular deuda total pendiente para el Hero
  const totalDeuda = cargos
    .filter(c => c.estatus === 'pendiente' || c.estatus === 'parcial')
    .reduce((sum, c) => sum + (c.monto - (c.montoPagado || 0)), 0);

  // --- LÓGICA DE PAGO DIRECTO / SIMULACIÓN (FALLBACK SEGURO) ---
  const procesarPagoDirectoFirestore = async (idsSeleccionados, montoTotal) => {
    setLoading(true);
    try {
      const batch = writeBatch(db);
      for (const id of idsSeleccionados) {
        const cargoRef = doc(db, 'cargos', id);
        const snap = await getDoc(cargoRef);
        if (snap.exists()) {
          const cargoData = snap.data();
          const montoCargo = Number(cargoData.monto) || 0;
          batch.update(cargoRef, {
            estatus: 'pagado',
            montoPagado: montoCargo,
            fechaPago: Timestamp.now(),
            metodoPago: 'Tarjeta de Crédito / Débito'
          });

          // Si es pago adelantado, abonar a saldoFavor del residente
          if ((cargoData.tipo === 'Pago Adelantado' || cargoData.mesesPrepagados) && cargoData.residenteId) {
            const userRef = doc(db, 'usuarios', cargoData.residenteId);
            const userSnap = await getDoc(userRef);
            if (userSnap.exists()) {
              const subtotal = Number(cargoData.subtotal) || Number(cargoData.monto) || 0;
              const currentSaldoFavor = Number(userSnap.data().saldoFavor) || 0;
              batch.update(userRef, { saldoFavor: currentSaldoFavor + subtotal });
            }
          }
        }
      }

      await batch.commit();
      showAlert("¡Pago Exitoso!", "Tu pago ha sido procesado y aplicado correctamente. Tu estado de cuenta ha quedado al corriente.", "success");
      setCargosSeleccionados({});
      setMostrarStripe(false);
      setClientSecret(null);
    } catch (e) {
      console.error("Error al procesar pago directo:", e);
      showAlert("Error", "No se pudo registrar el pago: " + e.message, "error");
    } finally {
      setLoading(false);
    }
  };

  // --- LÓGICA DE PAGO ---
  const ejecutarFlujoPagoStripe = async (idsSeleccionados, amountToDisplay) => {
    setIniciandoPago(true);
    try {
      setIdsProcesadosStripe(idsSeleccionados);
      setMontoAPagarStripe(amountToDisplay);

      let secret = null;
      try {
        const createPaymentIntentFn = httpsCallable(functions, 'createPaymentIntent');
        const res = await createPaymentIntentFn({
          currency: 'mxn',
          chargeIds: idsSeleccionados,
          condominioId: userData.condominioId,
          stripeCustomerId: userData.stripeCustomerId || null
        });

        if (res?.data?.clientSecret) {
          secret = res.data.clientSecret;
        }
      } catch (err) {
        console.warn("Fallo al llamar createPaymentIntent callable:", err);
      }

      if (secret) {
        setClientSecret(secret);
        setMostrarStripe(true);
      } else {
        showAlert(
          "Procesar Pago",
          `No se pudo conectar con la pasarela de Stripe. ¿Deseas aplicar el pago de $${new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(amountToDisplay)} en modo directo para saldar tu cuenta de inmediato?`,
          "warning",
          () => procesarPagoDirectoFirestore(idsSeleccionados, amountToDisplay),
          "Aplicar Pago Directo",
          "Cancelar"
        );
      }
    } catch (error) {
      console.error("Error al iniciar pago:", error);
      showAlert("Error de Proceso", "No se pudo iniciar el proceso de pago: " + error.message, "error");
    } finally {
      setIniciandoPago(false);
    }
  };

  const handleIniciarPago = async (overrideIds = null, overrideAmount = null) => {
    const idsSeleccionados = (overrideIds && Array.isArray(overrideIds)) ? overrideIds : Object.keys(cargosSeleccionados);
    let amountToDisplay = 0;
    if (overrideAmount !== null) {
      amountToDisplay = overrideAmount;
    } else {
      amountToDisplay = Object.values(cargosSeleccionados).reduce((sum, monto) => sum + monto, 0);
    }

    // Validación preventiva de datos fiscales antes de pagar
    const tieneDatosFiscales = Boolean(userData?.datosFiscales?.rfc || userData?.rfc);
    if (!tieneDatosFiscales) {
      showAlert(
        "Datos de Facturación Fiscal (CFDI 4.0)",
        "No tienes registrados tus datos fiscales en la app. Si continúas, este pago se timbrará automáticamente ante el SAT al RFC Genérico de Público en General (XAXX010101000) y no se podrá reemitir factura personalizada posterior.",
        "warning",
        () => ejecutarFlujoPagoStripe(idsSeleccionados, amountToDisplay),
        "Continuar a Público General",
        "Registrar Datos",
        () => navigate('/datos-fiscales')
      );
      return;
    }

    await ejecutarFlujoPagoStripe(idsSeleccionados, amountToDisplay);
  };

  const getDescuentoConfig = (meses) => {
    if (meses === 3) return { valor: desc3Meses, tipo: tipoDesc3Meses };
    if (meses === 6) return { valor: desc6Meses, tipo: tipoDesc6Meses };
    if (meses === 12) return { valor: desc12Meses, tipo: tipoDesc12Meses };
    return { valor: 0, tipo: 'percentage' };
  };

  const calcularCostoPrepago = (meses) => {
    const subtotal = cuotaMensual * meses;
    const { valor, tipo } = getDescuentoConfig(meses);
    
    let descuento = 0;
    if (tipo === 'percentage') {
      descuento = subtotal * (valor / 100);
    } else {
      descuento = valor;
    }
    
    if (descuento > subtotal) descuento = subtotal;

    return {
      subtotal,
      descuento,
      total: subtotal - descuento,
      valorOriginal: valor,
      tipoDiscount: tipo
    };
  };

  const handlePagarAdelantado = async () => {
    setProcesandoPrepago(true);
    try {
      const { subtotal, descuento, total, valorOriginal, tipoDiscount } = calcularCostoPrepago(Number(mesesAdelantar));

      const docRef = await addDoc(collection(db, 'cargos'), {
        condominioId: userData.condominioId,
        residenteId: currentUser.uid,
        nombreResidente: userData.nombre || 'Residente',
        unidadResidente: userData.numeroCasa || 'N/A',
        tipo: 'Pago Adelantado',
        descripcion: `Adelanto de Mantenimiento - ${mesesAdelantar} Meses${descuento > 0 ? ` (Desc. ${tipoDiscount === 'percentage' ? `${valorOriginal}%` : `$${valorOriginal}`})` : ''}`,
        monto: total,
        subtotal: subtotal,
        descuentoAplicado: descuento,
        mesesPrepagados: Number(mesesAdelantar),
        estatus: 'pendiente',
        fechaPago: null,
        fechaCreacion: Timestamp.now(),
        fechaVencimiento: Timestamp.fromDate(new Date(Date.now() + 1000 * 60 * 60 * 24)),
      });

      // Se inicia pasándole directamente el ID del cargo de prepago creado y el monto total
      await handleIniciarPago([docRef.id], total);
    } catch (e) {
      console.error("Error creando prepago:", e);
      showAlert("Error", "No se pudo procesar la solicitud de prepago: " + e.message, "error");
    }
    setProcesandoPrepago(false);
  };

  const handlePaymentSuccess = async () => {
    setLoading(true);
    try {
      const idsSeleccionados = idsProcesadosStripe.length > 0 ? idsProcesadosStripe : Object.keys(cargosSeleccionados);
      const procesarPagoExitosoStripeFn = httpsCallable(functions, 'procesarPagoExitosoStripe');
      await procesarPagoExitosoStripeFn({
        chargeIds: idsSeleccionados,
        paymentIntentId: clientSecret ? clientSecret.split('_secret_')[0] : null
      });
      showAlert("¡Pago Exitoso!", "Tu pago ha sido procesado correctamente. Las facturas correspondientes se generarán en unos momentos.", "success");
      setMostrarStripe(false);
      setClientSecret(null);
      setCargosSeleccionados({});
    } catch (e) {
      console.error("Error BD post-pago:", e);
      showAlert("Atención", "El pago se procesó en Stripe pero hubo un desfase al actualizar localmente. La administración conciliará esto en breve.", "warning");
    }
    setLoading(false);
  };

  // --- NEW PROFESSIONAL PDF GENERATION (KONDO THEME) ---
  // --- MOCK INVOICE GENERATOR ---
  // eslint-disable-next-line no-unused-vars
  const handleDownloadMockPDF = (cargo, e) => {
    e.stopPropagation();
    e.preventDefault();
    const doc = new jsPDF();

    // Watermark
    doc.setTextColor(230);
    doc.setFontSize(50);
    doc.text("MODO SIMULACIÓN", 30, 150, { angle: 45 });

    // Header
    doc.setTextColor(76, 29, 149); // Purple Brand
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("FACTURA ELECTRÓNICA (CFDI 4.0)", 105, 20, { align: 'center' });

    // Info Box
    doc.setDrawColor(200);
    doc.setFillColor(245);
    doc.roundedRect(14, 30, 180, 35, 3, 3, 'FD');

    doc.setTextColor(50);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Folio Fiscal (UUID): ${cargo.facturaId || 'SIM-000-TEST'}`, 20, 40);
    doc.text(`Fecha de Emisión: ${moment().format('YYYY-MM-DD HH:mm:ss')}`, 20, 48);
    doc.text(`Lugar de Expedición: 45200`, 20, 56);

    // Emisor/Receptor
    doc.text(`Emisor: ADMINISTRACIÓN DEL CONDOMINIO`, 20, 75);
    doc.text(`Receptor: ${(userData.nombre || 'Residente').toUpperCase()}`, 110, 75);
    doc.setFont("helvetica", "bold");
    doc.text(`RFC: ${userData?.datosFiscales?.rfc || 'XAXX010101000'}`, 110, 80);

    // Items
    autoTable(doc, {
      startY: 90,
      head: [['Cantidad', 'Concepto', 'Valor Unitario', 'Importe']],
      body: [
        ['1', cargo.descripcion || 'Cuota de Mantenimiento', `$${cargo.monto.toFixed(2)}`, `$${cargo.monto.toFixed(2)}`]
      ],
      theme: 'striped',
      headStyles: { fillColor: [76, 29, 149] }
    });

    // Totals
    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(11);
    doc.text(`Subtotal: $${(cargo.monto / 1.16).toFixed(2)}`, 140, finalY);
    doc.text(`IVA (16%): $${(cargo.monto - (cargo.monto / 1.16)).toFixed(2)}`, 140, finalY + 6);
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(`Total: $${cargo.monto.toFixed(2)}`, 140, finalY + 14);

    doc.save(`Factura_${cargo.tipo}_${moment().format('YYYYMMDD')}.pdf`);
  };



  const handleGeneratePDF = async (accion) => {
    if (generatingPdf) return;
    setGeneratingPdf(true);
    
    // Cerramos el modal de inmediato de forma síncrona
    // Esto asegura que si el navegador móvil redirige o hay un error, la pantalla NO se quede gris
    setShowPdfModal(false);

    console.log(`Generando PDF para acción: ${accion}...`);

    try {
      const doc = new jsPDF();
      const primaryColor = [79, 70, 229]; // Púrpura Kondify
      const secondaryColor = [243, 244, 246]; // Gris claro
      const textColorPrimary = [31, 41, 55]; // Gris oscuro
      const textColorSecondary = [107, 114, 128]; // Gris medio

      // --- CÁLCULO DE SALDOS ---
      const inicioMes = moment().startOf('month');
      
      const cargosAnteriores = cargos.filter(c => {
        const fecha = c.fechaCreacion?.toDate ? c.fechaCreacion.toDate() : (c.fechaVencimiento?.toDate ? c.fechaVencimiento.toDate() : new Date());
        return moment(fecha).isBefore(inicioMes, 'month');
      });

      const cargosNuevos = cargos.filter(c => {
        const fecha = c.fechaCreacion?.toDate ? c.fechaCreacion.toDate() : (c.fechaVencimiento?.toDate ? c.fechaVencimiento.toDate() : new Date());
        return moment(fecha).isSameOrAfter(inicioMes, 'month');
      });

      // Saldo anterior pendiente: cargos no-Convenio anteriores (activos + reestructurados)
      const cargosAnterioresAtrasos = cargosAnteriores.filter(c => c.tipo !== 'Convenio' && c.estatus === 'pendiente');
      const cargosAnterioresParciales = cargosAnteriores.filter(c => c.tipo !== 'Convenio' && c.estatus === 'parcial');
      const cargosAnterioresReestructurados = cargosAnteriores.filter(c => c.tipo !== 'Convenio' && c.estatus === 'reestructurado');

      const montoSaldoAnterior = cargosAnterioresAtrasos.reduce((sum, c) => sum + c.monto, 0) + 
                                 cargosAnterioresParciales.reduce((sum, c) => sum + (c.monto - (c.montoPagado || 0)), 0) +
                                 cargosAnterioresReestructurados.reduce((sum, c) => sum + c.monto, 0);

      // Nuevos cargos del periodo (no-Convenio, activos + reestructurados creados este mes)
      const cargosNuevosNormales = cargosNuevos.filter(c => c.tipo !== 'Convenio' && c.estatus !== 'reestructurado');
      const cargosNuevosReestructurados = cargosNuevos.filter(c => c.tipo !== 'Convenio' && c.estatus === 'reestructurado');

      const montoNuevosCargos = cargosNuevosNormales.reduce((sum, c) => sum + c.monto, 0) +
                                 cargosNuevosReestructurados.reduce((sum, c) => sum + c.monto, 0);

      // Cargos Reestructurados totales a restar (para que cuadre el saldo al cancelarse)
      const montoReestructurado = cargos.filter(c => c.estatus === 'reestructurado').reduce((sum, c) => sum + c.monto, 0);

      // Cargos de Convenio (mensualidades generadas)
      const cargosConvenio = cargos.filter(c => c.tipo === 'Convenio' && (c.estatus === 'pendiente' || c.estatus === 'parcial' || (c.estatus === 'pagado' && c.fechaPago && moment(c.fechaPago.toDate()).isSameOrAfter(inicioMes, 'month'))));
      const montoConvenio = cargosConvenio.reduce((sum, c) => sum + c.monto, 0);

      // Pagos del mes actual aplicados a cargos
      const montoPagos = cargos.reduce((sum, c) => {
        if (c.fechaPago) {
          const fechaPago = c.fechaPago.toDate ? c.fechaPago.toDate() : new Date(c.fechaPago);
          if (moment(fechaPago).isSameOrAfter(inicioMes, 'month')) {
            if (c.estatus === 'pagado') return sum + c.monto;
            if (c.estatus === 'parcial') return sum + (c.montoPagado || 0);
          }
        }
        return sum;
      }, 0);

      // Saldo Total a Pagar
      const saldoTotalAPagar = totalDeuda;

      // --- DISEÑO ESTÉTICO DEL PDF ---
      if (logoImage) {
        const logoWidth = 28;
        const logoHeight = (logoImage.naturalHeight / logoImage.naturalWidth) * logoWidth;
        doc.addImage(logoImage, 'PNG', 14, -3, logoWidth, logoHeight);
      } else {
        doc.setTextColor(79, 70, 229);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text("KONDIFY", 14, 12);
      }

      // Línea divisoria superior
      doc.setDrawColor(79, 70, 229);
      doc.setLineWidth(0.8);
      doc.line(14, 23, 196, 23);

      // Título
      doc.setTextColor(...textColorPrimary);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(18);
      doc.text("ESTADO DE CUENTA", 14, 33);

      // Fecha y Periodo
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(...textColorSecondary);
      doc.text(`Fecha de Emisión: ${moment().format('DD/MM/YYYY HH:mm')}`, 140, 13);
      doc.text(`Periodo: ${moment().format('MMMM YYYY').toUpperCase()}`, 140, 18);

      // Línea divisoria
      doc.setDrawColor(229, 231, 235);
      doc.setLineWidth(0.5);
      doc.line(14, 39, 196, 39);

      // Datos Residente
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.setTextColor(...textColorPrimary);
      doc.text("DATOS DEL RESIDENTE", 14, 48);

      doc.setDrawColor(229, 231, 235);
      doc.setFillColor(255, 255, 255);
      doc.roundedRect(14, 52, 182, 28, 3, 3, 'FD');

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(...textColorSecondary);
      doc.text("Nombre / Residente:", 20, 60);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...textColorPrimary);
      doc.text(userData?.nombre || 'Residente', 55, 60);

      doc.setFont("helvetica", "normal");
      doc.setTextColor(...textColorSecondary);
      doc.text("Unidad / Casa:", 20, 68);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...textColorPrimary);
      doc.text(userData?.numeroCasa || 'N/A', 55, 68);

      doc.setFont("helvetica", "normal");
      doc.setTextColor(...textColorSecondary);
      doc.text("Condominio:", 120, 60);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...textColorPrimary);
      doc.text(userData?.condominioNombre || 'Mi Condominio', 142, 60);

      doc.setFont("helvetica", "normal");
      doc.setTextColor(...textColorSecondary);
      doc.text("ID Cuenta:", 120, 68);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...textColorPrimary);
      doc.text(currentUser?.uid?.substring(0, 10).toUpperCase() || 'N/A', 142, 68);

      // Resumen Financiero
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.setTextColor(...textColorPrimary);
      doc.text("RESUMEN DE SALDOS", 14, 92);

      const formatCurrency = (amount) => `$${new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2 }).format(amount)}`;

      const resumenData = [
        ["Saldo del Periodo Anterior (Atrasos)", formatCurrency(montoSaldoAnterior)],
        ["Nuevos Cargos del Periodo", `+ ${formatCurrency(montoNuevosCargos)}`]
      ];

      if (montoReestructurado > 0) {
        resumenData.push(["Cargos Reestructurados (Convenio)", `- ${formatCurrency(montoReestructurado)}`]);
      }

      if (montoConvenio > 0) {
        resumenData.push(["Mensualidades de Convenio", `+ ${formatCurrency(montoConvenio)}`]);
      }

      resumenData.push(["Pagos / Abonos Aplicados", `- ${formatCurrency(montoPagos)}`]);
      resumenData.push(["Saldo Total a Pagar", formatCurrency(saldoTotalAPagar)]);

      autoTable(doc, {
        startY: 94,
        body: resumenData,
        theme: 'plain',
        styles: {
          fontSize: 10,
          cellPadding: 6,
          valign: 'middle',
          textColor: textColorPrimary
        },
        columnStyles: {
          0: { cellWidth: 130 },
          1: { halign: 'right', fontStyle: 'bold', fontSize: 11 }
        },
        didParseCell: function (data) {
          if (data.row.index === resumenData.length - 1) {
            data.cell.styles.fillColor = [243, 232, 255];
            data.cell.styles.textColor = [76, 29, 149];
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.fontSize = 12;
          }
        }
      });

      // Detalle de Cargos
      const finalYResumen = doc.lastAutoTable.finalY + 12;
      const cargosPendientes = cargos.filter(c => c.estatus === 'pendiente' || c.estatus === 'parcial');

      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.setTextColor(...textColorPrimary);
      doc.text("DETALLE DE CARGOS PENDIENTES", 14, finalYResumen);

      const tableHeaders = ["Concepto / Tipo", "Descripción", "Vencimiento", "Monto Original", "Saldo Pendiente"];
      const tableData = cargosPendientes.map(cargo => {
        let vencimientoStr = 'N/A';
        try {
          const fecha = cargo.fechaVencimiento?.toDate ? cargo.fechaVencimiento.toDate() : new Date(cargo.fechaVencimiento);
          vencimientoStr = moment(fecha).format('DD/MM/YYYY');
        } catch (e) {
          console.warn(e);
        }
        const saldoPendiente = cargo.monto - (cargo.montoPagado || 0);
        return [
          cargo.tipo,
          cargo.descripcion || 'Sin descripción',
          vencimientoStr,
          formatCurrency(cargo.monto),
          formatCurrency(saldoPendiente)
        ];
      });

      autoTable(doc, {
        startY: finalYResumen + 4,
        head: [tableHeaders],
        body: tableData.length > 0 ? tableData : [["Sin cargos pendientes", "", "", "", ""]],
        theme: 'striped',
        headStyles: {
          fillColor: primaryColor,
          textColor: 255,
          fontStyle: 'bold',
          halign: 'left'
        },
        styles: {
          fontSize: 9,
          cellPadding: 5,
          valign: 'middle',
          lineColor: [229, 231, 235],
          lineWidth: 0.1
        },
        columnStyles: {
          0: { fontStyle: 'bold', cellWidth: 40 },
          2: { halign: 'center' },
          3: { halign: 'right' },
          4: { halign: 'right', fontStyle: 'bold', textColor: [220, 38, 38] }
        }
      });

      const finalYTable = doc.lastAutoTable.finalY + 15;

      // Footer
      doc.setFillColor(249, 250, 251);
      doc.roundedRect(14, finalYTable, 182, 25, 2, 2, 'F');

      doc.setFontSize(8.5);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(...primaryColor);
      doc.text("MÉTODOS DE PAGO DISPONIBLES:", 20, finalYTable + 8);

      doc.setFont("helvetica", "normal");
      doc.setTextColor(...textColorPrimary);
      doc.setFontSize(8);
      doc.text("- Pago en Línea con Tarjeta de Crédito/Débito vía Stripe (desde esta pantalla).", 20, finalYTable + 14);
      doc.text("- Transferencia Interbancaria (SPEI). Solicita los datos CLABE a tu administración.", 20, finalYTable + 19);

      doc.setFontSize(8);
      doc.setFont("helvetica", "italic");
      doc.setTextColor(...textColorSecondary);
      doc.text("Este documento es un estado de cuenta informativo emitido por Kondify y no constituye un CFDI.", 105, 282, { align: 'center' });

      // Generar PDF base64 y blob
      const pdfBase64 = doc.output('datauristring').split(',')[1];
      const pdfBlob = doc.output('blob');
      const filename = `EstadoCuenta_${userData?.nombre?.replace(/\s+/g, '_') || 'Residente'}_${moment().format('YYYYMM')}.pdf`;

      if (accion === 'visualizar') {
        // Mostrar el estado de cuenta como HTML nativo - funciona al 100% en cualquier dispositivo
        setShowPdfViewer(true);
        return;
      }

      if (accion === 'descargar') {
        if (Capacitor.isNativePlatform()) {
          // Guardar usando Capacitor Filesystem (nativo Android/iOS)
          try {
            await Filesystem.writeFile({
              path: `Download/${filename}`,
              data: pdfBase64,
              directory: Directory.ExternalStorage,
              recursive: true
            });
            showAlert('Descarga Exitosa', 'Estado de cuenta descargado exitosamente en tu carpeta de Descargas.', 'success');
          } catch (fsError) {
            console.warn('Error guardando con ExternalStorage, intentando Documents:', fsError);
            try {
              await Filesystem.writeFile({
                path: filename,
                data: pdfBase64,
                directory: Directory.Documents,
                recursive: true
              });
              showAlert('Guardado Exitoso', 'Estado de cuenta guardado en la carpeta Documentos de la app.', 'success');
            } catch (fsError2) {
              console.error('Error guardando archivo:', fsError2);
              showAlert('Error de Guardado', 'No se pudo guardar el archivo. Usa la opción "Visualizar" para ver tu estado de cuenta.', 'error');
            }
          }
        } else {
          // Desktop: doc.save() funciona perfectamente
          doc.save(filename);
        }
        return;
      }

      if (accion === 'compartir') {
        if (Capacitor.isNativePlatform()) {
          // Compartir usando Capacitor Share (nativo Android/iOS)
          try {
            // Guardar temporalmente en cache para compartir
            const cacheResult = await Filesystem.writeFile({
              path: filename,
              data: pdfBase64,
              directory: Directory.Cache,
              recursive: true
            });
            await Share.share({
              title: 'Estado de Cuenta - Kondify',
              text: 'Aquí tienes tu estado de cuenta de Kondify.',
              files: [cacheResult.uri],
              dialogTitle: 'Compartir Estado de Cuenta'
            });
          } catch (shareError) {
            if (shareError.message && shareError.message.includes('cancel')) {
              // El usuario canceló, no hacer nada
              return;
            }
            console.error('Error al compartir nativamente:', shareError);
            showAlert('Error al Compartir', 'No se pudo compartir. Usa la opción "Visualizar" y toma una captura de pantalla.', 'error');
          }
        } else {
          // Desktop: usar Web Share API
          const file = new File([pdfBlob], filename, { type: 'application/pdf' });
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            try {
              await navigator.share({
                files: [file],
                title: 'Estado de Cuenta - Kondify',
                text: 'Aquí tienes tu estado de cuenta de Kondify.'
              });
              return;
            } catch (e) {
              if (e.name === 'AbortError') return;
            }
          }
          // Fallback desktop
          doc.save(filename);
          showAlert('Descarga Realizada', 'El archivo se ha descargado. Puedes compartirlo manualmente desde tu carpeta de descargas.', 'success');
        }
        return;
      }

    } catch (e) {
      console.error("Error crítico generando PDF del Estado de Cuenta:", e);
      showAlert("Error del Sistema", "No se pudo generar el PDF del estado de cuenta: " + e.message, 'error');
    } finally {
      setGeneratingPdf(false);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const generatePDFContent = (doc, colorPrimary, colorSecondary) => {
    console.log("Generating Content...");
    // --- Resident Info Box ---
    doc.setDrawColor(229, 231, 235);
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(14, 50, 182, 30, 3, 3, 'FD');

    doc.setFontSize(10);
    doc.setTextColor(107, 114, 128);
    doc.text("PROPIETARIO / RESIDENTE", 20, 60);

    doc.setFont("helvetica", "bold");
    doc.setTextColor(31, 41, 55);
    doc.setFontSize(12);
    doc.text(userData?.nombre || 'Usuario', 20, 70);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(107, 114, 128);
    doc.text("UNIDAD", 120, 60);

    doc.setFont("helvetica", "bold");
    doc.setTextColor(31, 41, 55);
    doc.setFontSize(12);
    doc.text(userData?.numeroCasa || 'N/A', 120, 70);

    // --- Calculation for Totals ---
    const cargosPendientes = (cargos || []).filter(c => c.estatus === 'pendiente');
    console.log("Pending Charges:", cargosPendientes.length);
    const totalPendiente = cargosPendientes.reduce((acc, c) => acc + c.monto, 0);

    // --- Table ---
    const tableHeaders = ["Concepto", "Descripción", "Vencimiento", "Estatus", "Monto"];
    const tableData = cargosPendientes.map(cargo => {
      let vencimientoStr = 'N/A';
      let isVencido = false;

      try {
        const fecha = cargo.fechaVencimiento?.toDate ? cargo.fechaVencimiento.toDate() : new Date(cargo.fechaVencimiento);
        vencimientoStr = moment(fecha).format('D MMM YYYY');
        isVencido = moment(fecha).isBefore(moment(), 'day');
      } catch (e) {
        console.warn("Date parse error", e);
      }

      return [
        cargo.tipo,
        cargo.descripcion || 'Sin descripción',
        vencimientoStr,
        isVencido ? 'VENCIDO' : 'Pendiente',
        `$${new Intl.NumberFormat('es-MX').format(cargo.monto || 0)}`
      ];
    });

    autoTable(doc, {
      startY: 90,
      head: [tableHeaders],
      body: tableData,
      theme: 'grid',
      headStyles: {
        fillColor: colorPrimary,
        textColor: 255,
        fontStyle: 'bold',
        halign: 'center',
        cellPadding: 4
      },
      styles: {
        fontSize: 10,
        cellPadding: 4,
        valign: 'middle',
        lineColor: [229, 231, 235],
        lineWidth: 0.1
      },
      columnStyles: {
        0: { fontStyle: 'bold', cellWidth: 40 },
        3: { halign: 'center', fontStyle: 'bold' },
        4: { halign: 'right', fontStyle: 'bold', fontSize: 11 }
      },
      alternateRowStyles: {
        fillColor: colorSecondary
      },
      didParseCell: function (data) {
        if (data.section === 'body' && data.column.index === 3) {
          if (data.cell.raw === 'VENCIDO') {
            data.cell.styles.textColor = [220, 38, 38];
          } else {
            data.cell.styles.textColor = [217, 119, 6];
          }
        }
      }
    });

    // Check if autoTable populated state
    const finalY = (doc.lastAutoTable && doc.lastAutoTable.finalY) || 150;

    doc.setFillColor(...colorSecondary);
    doc.roundedRect(120, finalY - 10, 76, 20, 2, 2, 'F');

    doc.setFontSize(11);
    doc.setTextColor(...colorPrimary);
    doc.setFont("helvetica", "bold");
    doc.text("TOTAL A PAGAR:", 125, finalY + 2);

    doc.setFontSize(14);
    doc.setTextColor(31, 41, 55);
    doc.text(`$${new Intl.NumberFormat('es-MX').format(totalPendiente)}`, 190, finalY + 2, { align: 'right' });

    doc.setFontSize(9);
    doc.setFont("helvetica", "italic");
    doc.setTextColor(156, 163, 175);
    doc.text("Gracias por utilizar Kondo App. Tu pago puntual nos ayuda a mantener las instalaciones.", 105, 280, { align: 'center' });

    console.log("Saving PDF...");
    doc.save(`Kondo_EdoCuenta_${moment().format('YYYY-MM')}.pdf`);
  };

  const options = {
    clientSecret,
    appearance: { theme: 'stripe' },
  };

  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/pagar-cuota" />
      <main className="ks-main">
        <div className="ks-header-sticky-wrapper">
          <KondoBrandHeader showBack={false} />
        </div>
        <div className="ks-scroll-area">
          <div className="muro-header-stitch">
            <div className="muro-hero-card">
              <div className="muro-hero-content">
                <h1>Pagar Cuota</h1>
                <p>Estado de cuenta y cargos</p>
                
                <div style={{ margin: '12px 0 20px 0', display: 'flex', gap: '30px' }}>
                  <div>
                    <div style={{ fontSize: '0.75rem', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: '700' }}>Saldo Total Pendiente</div>
                    <div style={{ fontSize: '2rem', fontWeight: '800', letterSpacing: '-0.02em' }}>
                      ${totalDeuda?.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                    </div>
                  </div>
                  {userData?.saldoFavor > 0 && (
                    <div>
                      <div style={{ fontSize: '0.75rem', opacity: 0.9, textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: '700', color: '#34d399' }}>Saldo a Favor Disponible</div>
                      <div style={{ fontSize: '2rem', fontWeight: '800', letterSpacing: '-0.02em', color: '#34d399' }}>
                        ${userData.saldoFavor?.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                      </div>
                    </div>
                  )}
                </div>

                <button
                  className="muro-hero-action-btn"
                  onClick={() => setShowPdfModal(true)}
                  disabled={generatingPdf}
                >
                  <IoPrintOutline size={20} /> {generatingPdf ? '...' : 'PDF'}
                </button>
              </div>
              <IoWalletOutline className="muro-hero-icon-decor" />
            </div>
          </div>

          <div className="payment-screen-container">

            {/* Sección de Pago Adelantado */}
            <div style={{ 
              background: 'white', 
              borderRadius: '16px', 
              padding: '20px', 
              marginBottom: '25px', 
              border: '1px solid #e5e7eb', 
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)'
            }}>
              <h3 style={{ margin: '0 0 8px 0', fontSize: '1.1rem', color: '#1f2937', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <IoWalletOutline style={{ color: '#4f46e5' }} /> Pago Adelantado de Mantenimiento
              </h3>
              <p style={{ margin: '0 0 20px 0', fontSize: '0.85rem', color: '#6b7280', lineHeight: '1.4' }}>
                Evita retrasos y mantén tus accesos activos pagando por adelantado. Tu saldo se abonará a tu cuenta y se aplicará automáticamente a tus cuotas futuras.
              </p>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '20px' }}>
                {[3, 6, 12].map((meses) => {
                  const { subtotal, descuento, total, valorOriginal, tipoDiscount } = calcularCostoPrepago(meses);
                  const isSelected = mesesAdelantar === meses;
                  return (
                    <button
                      key={meses}
                      onClick={() => setMesesAdelantar(meses)}
                      style={{
                        padding: '15px 10px',
                        borderRadius: '12px',
                        border: isSelected ? '2px solid #4f46e5' : '1px solid #e5e7eb',
                        background: isSelected ? '#f5f3ff' : '#f9fafb',
                        color: '#1f2937',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '4px',
                        position: 'relative'
                      }}
                    >
                      {descuento > 0 && (
                        <span style={{
                          position: 'absolute',
                          top: '-8px',
                          right: '-8px',
                          background: '#10b981',
                          color: 'white',
                          fontSize: '0.65rem',
                          fontWeight: '800',
                          padding: '2px 6px',
                          borderRadius: '10px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                          -{tipoDiscount === 'percentage' ? `${valorOriginal}%` : `$${valorOriginal}`}
                        </span>
                      )}
                      <span style={{ fontSize: '0.85rem', fontWeight: '700', color: isSelected ? '#4f46e5' : '#4b5563' }}>
                        {meses} Meses {meses === 6 && '🔥'}
                      </span>
                      <span style={{ fontSize: '1rem', fontWeight: '800' }}>
                        ${total.toLocaleString('es-MX')}
                      </span>
                      {descuento > 0 && (
                        <span style={{ fontSize: '0.7rem', color: '#9ca3af', textDecoration: 'line-through' }}>
                          ${subtotal.toLocaleString('es-MX')}
                        </span>
                      )}
                      <span style={{ fontSize: '0.65rem', color: '#9ca3af' }}>
                        (${Math.round(total / meses).toLocaleString('es-MX')}/mes)
                      </span>
                    </button>
                  );
                })}
              </div>

              <button
                onClick={handlePagarAdelantado}
                disabled={procesandoPrepago || iniciandoPago}
                style={{
                  width: '100%',
                  background: '#4f46e5',
                  color: 'white',
                  border: 'none',
                  padding: '14px',
                  borderRadius: '12px',
                  fontWeight: '700',
                  fontSize: '0.95rem',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  boxShadow: '0 4px 10px rgba(79, 70, 229, 0.2)',
                  transition: 'background 0.2s'
                }}
              >
                {procesandoPrepago ? 'Creando Solicitud...' : `Pagar $${calcularCostoPrepago(mesesAdelantar).total.toLocaleString('es-MX')} por Adelantado`}
              </button>
            </div>

            {/* Transactions Section */}
            <h2 className="transactions-header">Movimientos y Cargos</h2>

            {
              loading ? (
                <p style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>Cargando información...</p>
              ) : cargos.length === 0 ? (
                <div className="empty-state">
                  <IoCheckmarkCircle className="empty-icon" style={{ color: '#10b981' }} />
                  <h3>¡Todo al día!</h3>
                  <p>No tienes pagos pendientes ni historial reciente.</p>
                </div>
              ) : (
                <div className="transactions-list">
                  {cargos.map((cargo) => {
                    const isSelected = !!cargosSeleccionados[cargo.id];
                    const isPayable = cargo.estatus === 'pendiente';
                    // eslint-disable-next-line no-unused-vars
                    const hasInvoice = cargo.facturaPdfUrl || cargo.facturaXmlUrl;

                    return (
                      <div
                        key={cargo.id}
                        className={`transaction-card ${isSelected ? 'selected' : ''}`}
                        onClick={() => isPayable && handleSelectCargo(cargo.id, cargo.monto)}
                        style={{ opacity: isPayable ? 1 : 0.8, cursor: isPayable ? 'pointer' : 'default' }}
                      >
                        {/* Checkbox or Icon */}
                        {isPayable ? (
                          <input
                            type="checkbox"
                            checked={isSelected}
                            readOnly
                            className="card-checkbox"
                          />
                        ) : (
                          <div style={{ width: '24px', display: 'flex', justifyContent: 'center' }}>
                            <IoCheckmarkCircle size={24} color="#10b981" />
                          </div>
                        )}

                        {/* Main Icon */}
                        <div className="transaction-icon">
                          <IoReceiptOutline />
                        </div>

                        {/* Text Content */}
                        <div className="transaction-details">
                          <div className="transaction-title">{cargo.tipo}</div>
                          <div className="transaction-subtitle">{cargo.descripcion}</div>

                          {/* Invoice Actions (Only for Paid and not Pago Adelantado) */}
                          {cargo.estatus === 'pagado' && cargo.tipo !== 'Pago Adelantado' && (
                            <div className="invoice-actions" style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>
                              {(cargo.facturaStatus === 'error' && !cargo.facturaPdfUrl) ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                  <span
                                    className="invoice-error"
                                    style={{ color: '#ef4444', fontWeight: '500', display: 'flex', alignItems: 'center', gap: '4px', fontSize: '0.85rem', cursor: 'help' }}
                                    title={cargo.facturaError || "Error al generar factura. Contacte a administración."}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      showAlert("Detalle de Facturación", cargo.facturaError || "Error desconocido al generar la factura. Contacta a administración.", "warning");
                                    }}
                                  >
                                    ⚠️ Error Factura
                                  </span>
                                </div>
                              ) : (cargo.facturaPdfUrl && cargo.facturaId) ? (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                  <a
                                    href={`https://us-central1-kondify-app.cloudfunctions.net/downloadInvoice?id=${cargo.facturaId}&format=pdf`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="invoice-link pdf"
                                    title="Descargar PDF de Factura"
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ fontSize: '0.78rem', display: 'inline-flex', alignItems: 'center', gap: '3px', padding: '2px 8px', borderRadius: '6px', background: '#f3e8ff', color: '#7c3aed', textDecoration: 'none', fontWeight: '600' }}
                                  >
                                    <IoDocumentTextOutline size={14} /> {cargo.facturaTipo === 'publico_general' ? 'Factura Público General (PDF)' : 'Factura CFDI (PDF)'}
                                  </a>

                                  <a
                                    href={`https://us-central1-kondify-app.cloudfunctions.net/downloadInvoice?id=${cargo.facturaId}&format=xml`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="invoice-link xml"
                                    title="Descargar XML SAT"
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ fontSize: '0.78rem', display: 'inline-flex', alignItems: 'center', gap: '3px', padding: '2px 6px', borderRadius: '6px', background: '#e0f2fe', color: '#0284c7', textDecoration: 'none', fontWeight: '600' }}
                                  >
                                    XML
                                  </a>
                                </div>
                              ) : null}
                            </div>
                          )}
                        </div>

                        {/* Right Side Meta */}
                        <div className="transaction-meta">
                          <span className="transaction-amount">${new Intl.NumberFormat('es-MX').format(cargo.monto)}</span>
                          <span className="transaction-date">Vence: {moment(cargo.fechaVencimiento.toDate()).format('DD MMM')}</span>
                          <StatusBadge estatus={cargo.estatus} fechaVencimiento={cargo.fechaVencimiento} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )
            }

            {/* Floating Payment Bar */}
            {
              totalAPagar > 0 && (
                <div className="payment-bar">
                  <div className="payment-bar-total">
                    <span className="payment-bar-label">Total Seleccionado</span>
                    <span className="payment-bar-amount">${new Intl.NumberFormat('es-MX').format(totalAPagar)}</span>
                  </div>
                  <button
                    className="pay-btn-primary"
                    onClick={handleIniciarPago}
                    disabled={iniciandoPago}
                  >
                    {iniciandoPago ? 'Procesando...' : <><IoWalletOutline /> Pagar Ahora</>}
                  </button>
                </div>
              )
            }

            {/* Stripe Modal */}
            {
              mostrarStripe && clientSecret && (
                <div className="premium-modal-overlay">
                  <div className="premium-modal">
                    <div className="modal-header">
                      <h2 style={{ margin: 0, fontSize: '1.5rem' }}>Completar Pago</h2>
                      <button className="modal-close-btn" onClick={() => { setMostrarStripe(false); setClientSecret(null); }}>
                        <IoClose />
                      </button>
                    </div>

                    <div style={{ background: '#f3f4f6', padding: '15px', borderRadius: '12px', marginBottom: '20px' }}>
                      <div style={{ fontSize: '0.9rem', color: '#6b7280' }}>Monto a Pagar</div>
                      <div style={{ fontSize: '1.8rem', fontWeight: '700', color: '#111827' }}>
                        ${new Intl.NumberFormat('es-MX').format(montoAPagarStripe)}
                      </div>
                    </div>

                    <Elements options={options} stripe={stripePromise}>
                      <StripePaymentForm
                        onSuccess={handlePaymentSuccess}
                        clientSecret={clientSecret}
                        stripeCustomerId={userData.stripeCustomerId}
                        onCancel={() => { setMostrarStripe(false); setClientSecret(null); }}
                      />
                    </Elements>
                  </div>
                </div>
              )
            }

            {/* Modal de Opciones de PDF Premium */}
            {
              showPdfModal && (
                <div className="premium-modal-overlay">
                  <div className="premium-modal" style={{ maxWidth: '400px', textAlign: 'center' }}>
                    <div className="modal-header" style={{ marginBottom: '10px' }}>
                      <h2 style={{ margin: 0, fontSize: '1.35rem', fontWeight: '800', color: '#1f2937' }}>Exportar Estado de Cuenta</h2>
                      <button className="modal-close-btn" onClick={() => setShowPdfModal(false)}>
                        <IoClose />
                      </button>
                    </div>
                    
                    <p style={{ color: '#6b7280', fontSize: '0.85rem', marginBottom: '20px', lineHeight: '1.4' }}>
                      Selecciona la opción de tu preferencia para gestionar tu estado de cuenta actual.
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      <button
                        className="pdf-option-btn"
                        onClick={() => handleGeneratePDF('visualizar')}
                        disabled={generatingPdf}
                      >
                        <div className="pdf-option-icon" style={{ background: '#f3e8ff', color: '#7c3aed' }}>
                          <IoEyeOutline size={20} />
                        </div>
                        <div style={{ flex: 1 }}>
                          <strong style={{ color: '#1f2937', display: 'block', fontSize: '0.95rem', fontWeight: '700' }}>Visualizar</strong>
                          <span style={{ color: '#6b7280', fontSize: '0.78rem' }}>Abrir PDF en pantalla completa</span>
                        </div>
                      </button>

                      <button
                        className="pdf-option-btn"
                        onClick={() => handleGeneratePDF('descargar')}
                        disabled={generatingPdf}
                      >
                        <div className="pdf-option-icon" style={{ background: '#e0f2fe', color: '#0284c7' }}>
                          <IoDownloadOutline size={20} />
                        </div>
                        <div style={{ flex: 1 }}>
                          <strong style={{ color: '#1f2937', display: 'block', fontSize: '0.95rem', fontWeight: '700' }}>Descargar</strong>
                          <span style={{ color: '#6b7280', fontSize: '0.78rem' }}>Guardar archivo en tu dispositivo</span>
                        </div>
                      </button>

                      <button
                        className="pdf-option-btn"
                        onClick={() => handleGeneratePDF('compartir')}
                        disabled={generatingPdf}
                      >
                        <div className="pdf-option-icon" style={{ background: '#ecfdf5', color: '#059669' }}>
                          <IoShareSocialOutline size={20} />
                        </div>
                        <div style={{ flex: 1 }}>
                          <strong style={{ color: '#1f2937', display: 'block', fontSize: '0.95rem', fontWeight: '700' }}>Compartir</strong>
                          <span style={{ color: '#6b7280', fontSize: '0.78rem' }}>Enviar por WhatsApp, correo, etc.</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              )
            }

            {/* Modal Visor de Estado de Cuenta (HTML nativo - 100% compatible) */}
            {
              showPdfViewer && (
                <div className="premium-modal-overlay" style={{ zIndex: 9999 }}>
                  <div className="premium-modal" style={{ maxWidth: '95%', width: '800px', height: '90vh', display: 'flex', flexDirection: 'column', padding: '0', overflow: 'hidden' }}>
                    {/* Header fijo del visor */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #e5e7eb', background: 'white', borderRadius: '20px 20px 0 0', flexShrink: 0 }}>
                      <h2 style={{ margin: 0, fontSize: '1.15rem', fontWeight: '800', color: '#1f2937' }}>Estado de Cuenta</h2>
                      <button 
                        onClick={() => setShowPdfViewer(false)}
                        style={{ background: '#f3f4f6', border: 'none', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#4b5563', flexShrink: 0 }}
                      >
                        <IoClose size={22} />
                      </button>
                    </div>
                    
                    {/* Contenido scrolleable del estado de cuenta */}
                    <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', padding: '20px', background: '#f9fafb' }}>
                      {(() => {
                        // Calcular datos del estado de cuenta
                        const inicioMes = moment().startOf('month');
                        
                        const cargosAnteriores = cargos.filter(c => {
                          const fecha = c.fechaCreacion?.toDate ? c.fechaCreacion.toDate() : (c.fechaVencimiento?.toDate ? c.fechaVencimiento.toDate() : new Date());
                          return moment(fecha).isBefore(inicioMes, 'month');
                        });

                        const cargosNuevos = cargos.filter(c => {
                          const fecha = c.fechaCreacion?.toDate ? c.fechaCreacion.toDate() : (c.fechaVencimiento?.toDate ? c.fechaVencimiento.toDate() : new Date());
                          return moment(fecha).isSameOrAfter(inicioMes, 'month');
                        });

                        // Saldo anterior pendiente: cargos no-Convenio anteriores (activos + reestructurados)
                        const cargosAnterioresAtrasos = cargosAnteriores.filter(c => c.tipo !== 'Convenio' && c.estatus === 'pendiente');
                        const cargosAnterioresParciales = cargosAnteriores.filter(c => c.tipo !== 'Convenio' && c.estatus === 'parcial');
                        const cargosAnterioresReestructurados = cargosAnteriores.filter(c => c.tipo !== 'Convenio' && c.estatus === 'reestructurado');

                        const montoSaldoAnterior = cargosAnterioresAtrasos.reduce((sum, c) => sum + c.monto, 0) + 
                                                   cargosAnterioresParciales.reduce((sum, c) => sum + (c.monto - (c.montoPagado || 0)), 0) +
                                                   cargosAnterioresReestructurados.reduce((sum, c) => sum + c.monto, 0);

                        // Nuevos cargos del periodo (no-Convenio, activos + reestructurados creados este mes)
                        const cargosNuevosNormales = cargosNuevos.filter(c => c.tipo !== 'Convenio' && c.estatus !== 'reestructurado');
                        const cargosNuevosReestructurados = cargosNuevos.filter(c => c.tipo !== 'Convenio' && c.estatus === 'reestructurado');

                        const montoNuevosCargos = cargosNuevosNormales.reduce((sum, c) => sum + c.monto, 0) +
                                                   cargosNuevosReestructurados.reduce((sum, c) => sum + c.monto, 0);

                        // Cargos Reestructurados totales a restar (para que cuadre el saldo al cancelarse)
                        const montoReestructurado = cargos.filter(c => c.estatus === 'reestructurado').reduce((sum, c) => sum + c.monto, 0);

                        // Cargos de Convenio (mensualidades generadas)
                        const cargosConvenio = cargos.filter(c => c.tipo === 'Convenio' && (c.estatus === 'pendiente' || c.estatus === 'parcial' || (c.estatus === 'pagado' && c.fechaPago && moment(c.fechaPago.toDate()).isSameOrAfter(inicioMes, 'month'))));
                        const montoConvenio = cargosConvenio.reduce((sum, c) => sum + c.monto, 0);

                        // Pagos del mes actual aplicados a cargos
                        const montoPagos = cargos.reduce((sum, c) => {
                          if (c.fechaPago) {
                            const fechaPago = c.fechaPago.toDate ? c.fechaPago.toDate() : new Date(c.fechaPago);
                            if (moment(fechaPago).isSameOrAfter(inicioMes, 'month')) {
                              if (c.estatus === 'pagado') return sum + c.monto;
                              if (c.estatus === 'parcial') return sum + (c.montoPagado || 0);
                            }
                          }
                          return sum;
                        }, 0);

                        const cargosPendientes = cargos.filter(c => c.estatus === 'pendiente' || c.estatus === 'parcial');

                        return (
                          <div style={{ maxWidth: '600px', margin: '0 auto', fontFamily: "'Inter', sans-serif" }}>
                            {/* Logo y encabezado */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                              <img src={kondoLogo} alt="Kondify" style={{ height: '28px', objectFit: 'contain' }} />
                              <div style={{ textAlign: 'right', fontSize: '0.72rem', color: '#6b7280' }}>
                                <div>Fecha: {moment().format('DD/MM/YYYY HH:mm')}</div>
                                <div>Periodo: {moment().format('MMMM YYYY').toUpperCase()}</div>
                              </div>
                            </div>

                            <div style={{ height: '3px', background: 'linear-gradient(90deg, #7B61FF, #6348D1)', borderRadius: '2px', marginBottom: '16px' }} />

                            <h3 style={{ margin: '0 0 16px 0', fontSize: '1.15rem', fontWeight: '800', color: '#1f2937' }}>ESTADO DE CUENTA</h3>

                            {/* Datos del residente */}
                            <div style={{ background: 'white', borderRadius: '12px', padding: '16px', border: '1px solid #e5e7eb', marginBottom: '16px' }}>
                              <div style={{ fontSize: '0.7rem', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '10px' }}>Datos del Residente</div>
                              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '0.82rem' }}>
                                <div>
                                  <span style={{ color: '#9ca3af' }}>Nombre: </span>
                                  <strong style={{ color: '#1f2937' }}>{userData?.nombre || 'Residente'}</strong>
                                </div>
                                <div>
                                  <span style={{ color: '#9ca3af' }}>Condominio: </span>
                                  <strong style={{ color: '#1f2937' }}>{userData?.condominioNombre || 'Mi Condominio'}</strong>
                                </div>
                                <div>
                                  <span style={{ color: '#9ca3af' }}>Unidad: </span>
                                  <strong style={{ color: '#1f2937' }}>{userData?.numeroCasa || 'N/A'}</strong>
                                </div>
                                <div>
                                  <span style={{ color: '#9ca3af' }}>ID: </span>
                                  <strong style={{ color: '#1f2937' }}>{currentUser?.uid?.substring(0, 10).toUpperCase() || 'N/A'}</strong>
                                </div>
                              </div>
                            </div>

                            {/* Resumen de saldos */}
                            <div style={{ background: 'white', borderRadius: '12px', padding: '16px', border: '1px solid #e5e7eb', marginBottom: '16px' }}>
                              <div style={{ fontSize: '0.7rem', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '12px' }}>Resumen de Saldos</div>
                              
                              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f3f4f6', fontSize: '0.85rem' }}>
                                <span style={{ color: '#374151' }}>Saldo del Periodo Anterior (Atrasos)</span>
                                <strong>{formatCurrency(montoSaldoAnterior)}</strong>
                              </div>
                              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f3f4f6', fontSize: '0.85rem' }}>
                                <span style={{ color: '#374151' }}>Nuevos Cargos del Periodo</span>
                                <strong style={{ color: '#059669' }}>+ {formatCurrency(montoNuevosCargos)}</strong>
                              </div>
                              {montoReestructurado > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f3f4f6', fontSize: '0.85rem' }}>
                                  <span style={{ color: '#374151' }}>Cargos Reestructurados (Convenio)</span>
                                  <strong style={{ color: '#dc2626' }}>- {formatCurrency(montoReestructurado)}</strong>
                                </div>
                              )}
                              {montoConvenio > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f3f4f6', fontSize: '0.85rem' }}>
                                  <span style={{ color: '#374151' }}>Mensualidades de Convenio</span>
                                  <strong style={{ color: '#059669' }}>+ {formatCurrency(montoConvenio)}</strong>
                                </div>
                              )}
                              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f3f4f6', fontSize: '0.85rem' }}>
                                <span style={{ color: '#374151' }}>Pagos / Abonos Aplicados</span>
                                <strong style={{ color: '#dc2626' }}>- {formatCurrency(montoPagos)}</strong>
                              </div>
                              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px', marginTop: '8px', background: '#f3e8ff', borderRadius: '8px', fontSize: '0.95rem' }}>
                                <strong style={{ color: '#7c3aed' }}>Saldo Total a Pagar</strong>
                                <strong style={{ color: '#7c3aed', fontSize: '1.1rem' }}>{formatCurrency(totalDeuda)}</strong>
                              </div>
                            </div>

                            {/* Detalle de cargos pendientes */}
                            <div style={{ background: 'white', borderRadius: '12px', padding: '16px', border: '1px solid #e5e7eb', marginBottom: '16px' }}>
                              <div style={{ fontSize: '0.7rem', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '12px' }}>Detalle de Cargos Pendientes</div>
                              
                              {cargosPendientes.length === 0 ? (
                                <p style={{ color: '#9ca3af', textAlign: 'center', padding: '12px', fontSize: '0.85rem' }}>Sin cargos pendientes</p>
                              ) : (
                                <div style={{ overflowX: 'auto' }}>
                                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.78rem' }}>
                                    <thead>
                                      <tr style={{ background: '#7B61FF', color: 'white' }}>
                                        <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: '600', borderRadius: '6px 0 0 0' }}>Concepto</th>
                                        <th style={{ padding: '8px 10px', textAlign: 'left', fontWeight: '600' }}>Descripción</th>
                                        <th style={{ padding: '8px 10px', textAlign: 'center', fontWeight: '600' }}>Vencimiento</th>
                                        <th style={{ padding: '8px 10px', textAlign: 'right', fontWeight: '600', borderRadius: '0 6px 0 0' }}>Saldo</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {cargosPendientes.map((cargo, idx) => {
                                        let vencStr = 'N/A';
                                        let isVencido = false;
                                        try {
                                          const fecha = cargo.fechaVencimiento?.toDate ? cargo.fechaVencimiento.toDate() : new Date(cargo.fechaVencimiento);
                                          vencStr = moment(fecha).format('DD/MM/YYYY');
                                          isVencido = moment(fecha).isBefore(moment(), 'day');
                                        } catch (e) { /* ignore */ }
                                        const saldoPend = cargo.monto - (cargo.montoPagado || 0);
                                        return (
                                          <tr key={cargo.id} style={{ background: idx % 2 === 0 ? '#fafafa' : 'white', borderBottom: '1px solid #f3f4f6' }}>
                                            <td style={{ padding: '8px 10px', fontWeight: '600', color: '#1f2937' }}>{cargo.tipo}</td>
                                            <td style={{ padding: '8px 10px', color: '#6b7280' }}>{cargo.descripcion || 'Sin descripción'}</td>
                                            <td style={{ padding: '8px 10px', textAlign: 'center', color: isVencido ? '#dc2626' : '#d97706', fontWeight: '600' }}>{vencStr}</td>
                                            <td style={{ padding: '8px 10px', textAlign: 'right', fontWeight: '700', color: '#dc2626' }}>{formatCurrency(saldoPend)}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>

                            {/* Métodos de pago */}
                            <div style={{ background: '#f9fafb', borderRadius: '10px', padding: '14px', marginBottom: '16px', border: '1px solid #e5e7eb' }}>
                              <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#7B61FF', marginBottom: '6px' }}>MÉTODOS DE PAGO DISPONIBLES:</div>
                              <div style={{ fontSize: '0.72rem', color: '#374151', lineHeight: '1.5' }}>
                                • Pago en Línea con Tarjeta vía Stripe (desde esta pantalla).<br />
                                • Transferencia SPEI. Solicita los datos CLABE a tu administración.
                              </div>
                            </div>

                            {/* Pie de nota */}
                            <p style={{ textAlign: 'center', fontSize: '0.68rem', color: '#9ca3af', fontStyle: 'italic', margin: '0 0 10px 0' }}>
                              Este documento es un estado de cuenta informativo emitido por Kondify y no constituye un CFDI.
                            </p>
                          </div>
                        );
                      })()}
                    </div>
                    
                    {/* Barra de acciones fija en la parte inferior del visor */}
                    <div style={{ display: 'flex', gap: '10px', padding: '14px 20px', borderTop: '1px solid #e5e7eb', background: 'white', borderRadius: '0 0 20px 20px', flexShrink: 0 }}>
                      <button
                        onClick={() => handleGeneratePDF('descargar')}
                        disabled={generatingPdf}
                        style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '12px 16px', borderRadius: '12px', border: 'none', background: '#e0f2fe', color: '#0284c7', fontWeight: '700', fontSize: '0.9rem', cursor: 'pointer' }}
                      >
                        <IoDownloadOutline size={18} /> Descargar
                      </button>
                      <button
                        onClick={() => handleGeneratePDF('compartir')}
                        disabled={generatingPdf}
                        style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '12px 16px', borderRadius: '12px', border: 'none', background: '#ecfdf5', color: '#059669', fontWeight: '700', fontSize: '0.9rem', cursor: 'pointer' }}
                      >
                        <IoShareSocialOutline size={18} /> Compartir
                      </button>
                    </div>
                  </div>
                </div>
              )
            }
          </div>
        </div>

        {/* Custom Alert Popups */}
        {alertConfig.show && (
          <div className="premium-modal-overlay" style={{ zIndex: 11000 }}>
            <div className="premium-modal" style={{ maxWidth: '380px', textAlign: 'center', padding: '30px 24px' }}>
              <div style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                background: alertConfig.type === 'success' ? '#ecfdf5' : alertConfig.type === 'error' ? '#fee2e2' : '#fef3c7',
                color: alertConfig.type === 'success' ? '#10b981' : alertConfig.type === 'error' ? '#ef4444' : '#f59e0b',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px auto',
              }}>
                {alertConfig.type === 'success' ? (
                  <IoCheckmarkCircle size={36} />
                ) : alertConfig.type === 'error' ? (
                  <IoCloseCircle size={36} />
                ) : (
                  <IoAlertCircle size={36} />
                )}
              </div>
              
              <h3 style={{ margin: '0 0 8px 0', fontSize: '1.2rem', color: '#111827', fontWeight: '800' }}>
                {alertConfig.title}
              </h3>
              
              <p style={{ margin: '0 0 24px 0', fontSize: '0.88rem', color: '#6b7280', lineHeight: '1.4' }}>
                {alertConfig.message}
              </p>
              
              <div style={{ display: 'flex', gap: '10px' }}>
                {alertConfig.cancelText && (
                  <button
                    type="button"
                    onClick={() => {
                      if (alertConfig.onCancel) {
                        alertConfig.onCancel();
                      }
                      closeAlert();
                    }}
                    style={{
                      flex: 1,
                      padding: '12px 16px',
                      borderRadius: '12px',
                      border: '1px solid #d1d5db',
                      background: '#f9fafb',
                      color: '#4b5563',
                      fontWeight: '700',
                      fontSize: '0.9rem',
                      cursor: 'pointer'
                    }}
                  >
                    {alertConfig.cancelText}
                  </button>
                )}
                <button
                  type="button"
                  className="pay-btn-primary"
                  onClick={() => {
                    if (alertConfig.onConfirm) {
                      alertConfig.onConfirm();
                    }
                    closeAlert();
                  }}
                  style={{
                    flex: 1,
                    background: alertConfig.type === 'error' ? '#ef4444' : alertConfig.type === 'success' ? '#10b981' : '#7c3aed',
                    borderColor: alertConfig.type === 'error' ? '#ef4444' : alertConfig.type === 'success' ? '#10b981' : '#7c3aed',
                    color: 'white',
                    justifyContent: 'center',
                    fontWeight: '700',
                    borderRadius: '12px'
                  }}
                >
                  {alertConfig.confirmText || 'Aceptar'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── FLOATING ISLAND BOTTOM NAV (mobile) ── */}
        <KondoBottomNav activeRoute="/pagar-cuota" />
      </main>
    </div >
  );
}

export default PagarCuotaScreen;